import { Component, Input } from '@angular/core';

@Component({
    selector: 'loading-spinner-border',
    imports: [],
    templateUrl: './loading-spinner-border.component.html'
})
export class LoadingSpinnerBorderComponent {
    @Input() size: string = "lg";

}
